import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { Redirect } from 'react-router-dom';

import Btn from '../../components/Btn';
import Inputs from '../Inputs';


class NewProject extends Component {
    static propTypes = {
        isLocked: PropTypes.bool.isRequired,
        annualInflation: PropTypes.number.isRequired,
        energyValue: PropTypes.number.isRequired,
        provider: PropTypes.number.isRequired,
        aFixedCharge: PropTypes.number.isRequired,
        annualDeg: PropTypes.number.isRequired,
        productionRatio: PropTypes.number.isRequired,
        solarValue: PropTypes.number.isRequired,
        cashprice: PropTypes.number.isRequired,
        systemSize: PropTypes.number.isRequired,
        sgipToggle: PropTypes.bool.isRequired,
        sgipValue: PropTypes.number.isRequired,
        esskW: PropTypes.number.isRequired,
        essPrice: PropTypes.number.isRequired,
        esskWh: PropTypes.number.isRequired,
        madeInCA: PropTypes.bool.isRequired,
        includeESS: PropTypes.bool.isRequired,
        ppaRate: PropTypes.number.isRequired,
        ppaTerm: PropTypes.number.isRequired,
        ppaEscalator: PropTypes.number.isRequired,
        taxRate: PropTypes.number.isRequired,
        installYear: PropTypes.number.isRequired,
        taxEntity: PropTypes.bool.isRequired,
        downPayment: PropTypes.number.isRequired,
        loanInterest: PropTypes.number.isRequired,
        loanTerm: PropTypes.number.isRequired,
        mosaicTerm: PropTypes.number.isRequired,
        mosaicDownPayment: PropTypes.number.isRequired,
        loanProvider: PropTypes.string.isRequired,
        showPPA: PropTypes.bool.isRequired,
        showLoan: PropTypes.bool.isRequired,
        showOBS: PropTypes.bool.isRequired,
        obsTerm: PropTypes.number.isRequired,
        obsDownPayment: PropTypes.number.isRequired,
        obsCredit: PropTypes.number.isRequired,
        setCreateIsVisible: PropTypes.func.isRequired,
        isVisible: PropTypes.bool.isRequired,
        annualKWH: PropTypes.number.isRequired,
        resiToggle: PropTypes.bool.isRequired,
        projectZip: PropTypes.number.isRequired,
        projectStreet: PropTypes.string.isRequired,
        projectStreet2: PropTypes.string.isRequired,
        projectName: PropTypes.string.isRequired,
        projectState: PropTypes.number.isRequired,
        projectCity: PropTypes.number.isRequired,
        projectCountry: PropTypes.number.isRequired,
        capTerm: PropTypes.number.isRequired,
        capDownPayment: PropTypes.number.isRequired,
        showCAP: PropTypes.bool.isRequired,
        includeCash: PropTypes.bool.isRequired,
        nyRebate: PropTypes.number.isRequired,
        installType: PropTypes.string.isRequired,
        installType2: PropTypes.string.isRequired,
        solarPanel: PropTypes.string.isRequired,
        inverter: PropTypes.string.isRequired,
        batteryType: PropTypes.string.isRequired,
        systemNotes: PropTypes.string.isRequired,
        archiveStatus: PropTypes.bool.isRequired,
        soldStatus: PropTypes.bool.isRequired,
        jobStatus: PropTypes.string.isRequired,
        smartValue: PropTypes.number.isRequired,
        clientId: PropTypes.number.isRequired,
    };

  handleChange = (e) => {
      this.setState({
          [e.target.id]: e.target.value,
      });
  }
  saveHandler= () => {
      const {
          isLocked,
          annualInflation,
          energyValue,
          provider,
          aFixedCharge,
          annualDeg,
          productionRatio,
          solarValue,
          cashprice,
          systemSize,
          sgipToggle,
          sgipValue,
          esskW,
          essPrice,
          esskWh,
          madeInCA,
          includeESS,
          ppaRate,
          ppaTerm,
          ppaEscalator,
          taxRate,
          installYear,
          taxEntity,
          downPayment,
          loanInterest,
          loanTerm,
          loanProvider,
          showPPA,
          showLoan,
          showOBS,
          obsTerm,
          obsDownPayment,
          obsCredit,
          annualKWH,
          resiToggle,
          projectZip,
          projectStreet,
          projectStreet2,
          projectName,
          projectState,
          projectCity,
          showCAP,
          capTerm,
          capDownPayment,
          mosaicTerm,
          mosaicDownPayment,
          includeCash,
          nyRebate,
          installType,
          installType2,
          solarPanel,
          inverter,
          batteryType,
          systemNotes,
          archiveStatus,
          soldStatus,
          jobStatus,
          projectCountry,
          smartValue,
          authToken,
          clientId,
      } = this.props;
      const project = {
          inputs: {
              clientId,
              includeCash,
              projectAddress: {
                  projectZip,
                  projectStreet,
                  projectStreet2,
                  projectName,
                  projectState,
                  projectCity,
                  projectCountry,
              },
              nyserda: {
                  nyRebate,
              },
              utility: {
                  annualInflation,
                  energyValue,
                  provider,
                  annualKWH,
                  aFixedCharge,
              },
              solar: {
                  annualDeg,
                  productionRatio,
                  solarValue,
                  cashprice,
                  systemSize,
                  installType,
                  installType2,
                  solarPanel,
                  inverter,
                  systemNotes,
              },
              sgip: {
                  sgipToggle,
                  sgipValue,
              },
              cap: {
                  showCAP,
                  capTerm,
                  capDownPayment,
              },
              smart: {
                  smartValue,
              },
              ess: {
                  esskW,
                  essPrice,
                  esskWh,
                  madeInCA,
                  includeESS,
                  batteryType,
              },
              ppa: {
                  ppaRate,
                  ppaTerm,
                  ppaEscalator,
                  showPPA,
              },
              loan: {
                  downPayment,
                  loanInterest,
                  loanTerm,
                  loanProvider,
                  showLoan,
                  mosaicTerm,
                  mosaicDownPayment,
              },
              obs: {
                  showOBS,
                  obsDownPayment,
                  obsTerm,
                  obsCredit,
              },
              tax: {
                  taxRate,
                  installYear,
                  taxEntity,
                  resiToggle,
              },
              settings: {
                  isLocked,
              },
              projectStatus: {
                  jobStatus,
                  archiveStatus,
                  soldStatus,
              },
          },
      };
      this.props.createProject(authToken, project);
      //this.props.history.push('/project{proejctId}');
  }

  toggleCreateVisiblity() {
      const { setCreateIsVisible, isVisible } = this.props;
      setCreateIsVisible(!isVisible);
  }

  render() {
      const { isLocked, authToken, createProjectErr } = this.props;
      if (!authToken) return <Redirect to="/" />;
      return (
          <div>
              <Inputs />
              {createProjectErr ?
                  <p>{createProjectErr}</p>
                  : null }
              <Btn
                  variant="contained"
                  label="Add Project"
                  disabled={isLocked}
                  onClick={this.saveHandler}
                  className="greenHover"
              />
          </div>
      );
  }
}

NewProject.propTypes = {
    createProject: PropTypes.func.isRequired,
    setCreateProjErr: PropTypes.func.isRequired,
    push: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    authToken: PropTypes.string.isRequired,
    createProjectErr: PropTypes.string.isRequired,
};

export default (NewProject);



// WEBPACK FOOTER //
// ./src/containers/NewProject/NewProject.js